<template>
	<div class="row">
		<div class="col-12">
			
			<card  title="Daily Report">
				<template slot="command">
					<!--<p-button :disabled="appointments.length<1 || loading" round class="btn btn-success" @click.native.prevent="excel_export">Export to Excel</p-button>-->
					<!--<p-button v-if="appointments.length>0 && !loading" round class="btn btn-success" @click.native.prevent="print">Print</p-button>-->
				</template>
				<div class="row mb-3">
					<div class="col-xl-4">
						<label>Date</label>
						<datepicker monday-first @input="onChangeDate" v-model="date" format="dd/MM/yyyy" input-class="form-control false-disabled"></datepicker>
					</div>
                    <!--<div class="col-xl-2 col-lg-2 align-self-end">
                       <p-button :disabled="this.filter===null || this.filter===''" :loading="loading" round class="btn btn-success" @click.native.prevent="loadAppointments()">Search</p-button>
                    </div>-->

				</div>
				<div class="row" id="print">
					<div class="col-12">
						
						<loader :loading="loading">
						<template v-for="employee in appointments" v-key="employee.id_employee" v-if="appointments.length>0">
							
							<h5>{{employee.employee.first_name + ' ' + employee.employee.last_name}}</h5>
							<small v-if="employee.employee.id_helper_employee!=null">Helper: {{employee.employee.helper.first_name + ' ' + employee.employee.helper.last_name }}</small>

							
							<b-table responsive small hover :items="employee.employee.appointments" :fields="columns" :busy='loading' show-empty >
								<template v-slot:table-busy>
									<loader :loading="loading"></loader>
								</template>
							</b-table>

						</template>
						<template v-if="appointments.length==0">
							No data this day
						</template>
						</loader>
					</div>
				</div>
			</card>
		</div>
	
	</div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import XLSX from 'xlsx';

export default {
	components: {
		Datepicker
	},
	data(){
		return {
			loading:false,
			filter:null,
			appointments:[],
            date:this.$moment().format('YYYY-MM-DD'),
			columns:[
				{
					key: "time",
					label: "Time"
				},
				{
					key: "client",
					label: "Client",
					formatter:(value)=>{
						return value.first_name+' '+value.last_name
					}
				},
				{
					key: "client.address",
					label: "Address"
				},
				{
					key: "detail",
					label: "Detail"
				},
				{
					key: "reference",
					label: "Reference"
				},
				{
					key: "note",
					label: "Notes"
				},
				{
					key: "id_appointment",
					label: "Job ref."
				},
			],
		}
	},
	methods:{
        async onChangeDate(){
			this.date = moment(this.date).format('YYYY-MM-DD')
			await this.loadAppointments();
        },
		async loadAppointments(){
            this.loading = true;

			let result = await this.$api.get('report/daily/'+this.date);
			this.appointments = result.data;
			
			
			this.loading = false;
		},
		print(){
			this.$print({
				header: '<h3 class="custom-h3">Report on filter: "'+this.filter+'"</h3>',
				printable: this.appointments.map(a=>{
					return{
						id_appointment:a.id_appointment,
						reference:a.reference ? a.reference : '',
						date:this.$moment(a.date).format('DD/MM/YYYY'),
						employee:a.employee.first_name+' '+a.employee.last_name,
						client:a.client.first_name+' '+a.client.last_name
					}
				}), 
				properties: [
					{field:'id_appointment',displayName:'#'},
					{field:'reference',displayName:'Reference'},
					{field:'date',displayName:'Date'}, 
					{field:"employee",displayName:'Employee'}, 
					{field:"client",displayName:'Client'},
				], 
				type: 'json'
			});
        }
	},
	async beforeMount(){
		await this.loadAppointments()
	}
}
</script>

<style>
</style>
